import { Voicemail } from "../../store/actions/voicemails/payloads";
import { Colors } from "../../styles/Colors";
import {makeStyles} from "@material-ui/core";

export type VoicemailDetailsDialogProps = {
    isOpen: boolean;
    toggleVisibility?: () => void;
    voicemail: Voicemail;
    timezoneOffset: number;
    onDeleteClick?: () => void;
    onDownloadClick?: (message_id: number) => void;
    extensionId: string;
    extensionName: string;
    i_account: number;
    onClickStarred?: (message_id: number, newValue: boolean) => void;
    customDownloadFileAction?: (message_uid: number, 
            callback: (url: string) => void, 
            restrictedCallback?: () => void) => void;
};

export const useStyles = makeStyles(() => ({

    noBold:{
      fontWeight:'normal'
    },

    noOverflow:{
        overflow:'unset'
    },

    rootContainer:{
      display:"flex",
      height:'100%',
      flex:1,
        width:'100%'
    },

    recordingActionContainer: {
        display: 'flex'
    },

    tabContainer: {
        paddingLeft: 0,
        paddingRight: 0,
        '& header': {
            backgroundColor: 'transparent',
            padding: '0px',
            marginLeft: '20px',
            marginRight: '20px',
            width: 'auto',

            '& button': {
                gap: '10px',
                padding: '2px 16px 0px 16px !important',
                height: '46',
                minWidth: '120px !important'

            },

            '& + div > div': {
                padding: '0px !important',
                margin: '0 8px'
            },
            '& + div + div > div': {
                padding: '0px !important',
                margin: '0 8px'
            }
        },
    },
    primaryActionButton: {
        '& .MuiButton-label': {
            color: Colors.Primary,
        },
    },
    header: {
        '& .MuiTypography-h6': {
            fontWeight: 'bold',
            fontSize: 18,
        },
    },
    modalContainer: {
        '& .MuiDialogContent-root': {
            width: 710,
            backgroundColor: Colors.SmokeBackground,
            minHeight: '546px'
        },
    },
    inputsContainer: {
        //padding: '0 12px 0 12px',
        display: 'flex',
        width:'100%',
        flexDirection: 'column',
        '& .MuiInputBase-root': {
            background: Colors.SmokeBackground,
        },
    },
    inputRow: {
        display: 'flex',
        marginTop: 22,

        '& .MuiFormControl-root': {
            flex: 1,
            margin: '0 6px',
        },
    },
    iconMargin: {
        marginLeft: 10,
    },
    buttonsContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: "end",
        width: 'fit-content'
    },
    tooltipContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '4px 8px',
    },
    tooltip: {
        display: 'flex',
        flex: 1,
        alignItems: 'center',
    },
    tooltipTitle: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        fontSize: '16px',
        lineHeight: '28px',
        marginRight: '8px',
        whiteSpace: 'pre-wrap',
    },
    container: {
        '& .MuiPaper-root': {
            width: 336,
        },

        '& .MuiDialogContent-root': {
            minWidth: 'unset !important',
            padding: '24px 24px 26px 24px !important',
            background: `${Colors.White} !important`,
        },
        '& .MuiDialogActions-root': {
            '& > :first-child': {
                marginRight: 20,
            },
        },
    },
    shorterInput: {
        maxWidth: 330,
    },

    cloud: {
        display: 'flex',
        alignItems: 'center',
        color: Colors.LightGraySecondary3,
        marginLeft: 23,
        marginRight: 12,
    },
    
    textfield: {
        width: 220,
        maxWidth: 220,
    },

    statusContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'row',
        marginRight: 24,
    },
    
    badge: {
        fontWeight: 400,
        fontSize: 12,
        lineHeight: '20px',
        minWidth: 48,
        width: 'fit-content',
        height: 20,
        borderRadius: 16,
        textAlign: 'center',
        padding: '0px 8px',
        border: '2px solid white'
    },
    activeBadge: {
        color: Colors.White,
        background: 'rgba(245, 132, 31, 1)'
    },
    inactiveBadge: {
        color: 'rgba(62, 92, 105, 1)',
        background: 'rgba(238, 240, 243, 1)'
    },
    answered: {
        color: Colors.White,
        background: 'rgba(117, 185, 67, 1)'
    },
    
    secondaryButton: {
        background: 'transparent',
        '& .MuiButton-label': {
            color: `${Colors.Secondary1}!important`,
            fontSize: '16px !important',
        }
    },

    customTranscriptionHeaderContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        flexDirection: 'row',
        padding: '10px 0px 0px 0px',
        marginTop: 26,
    },

    customTranscriptionHeaderText: {
        color: Colors.Text3,
        fontWeight: 400,
        fontSize: 12,
        lineHeight: '16px',
    },

    playerRootContainer: {
        padding: '19px 0px 0px 0px'
    },

    extendTextTranscription: {
        marginTop: 14
    },

    starContainer: {
        width: 'fit-content',
        height: 36,
        marginLeft: 16
    },
    
    starred: {
        color: 'rgba(245, 132, 31, 1)',

        '& svg > path': {
            fill: 'rgba(245, 132, 31, 1)'
        },

        cursor: 'pointer'
    },

    notStarred: {
        color: 'rgba(197, 213, 230, 1)',

        '& svg > path': {
            fill: 'rgba(197, 213, 230, 1)'
        },

        cursor: 'pointer'
    },

    customHeaderTitleClass: {
        lineHeight: '42px'
    },

    marginRight: {
        marginRight: 12,
    }
}));